/* global google */
import React from "react";
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import marker from "../../../../../images/marker-latinad.png";

import { withThemeMapStyles } from '../../../../../themes/mapTheme';
const ScreenMap = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: "100%" }} />,
    containerElement: <div style={{ height: "420px", borderRadius: "10px" }} />,
    mapElement: <div style={{ height: "100%", borderRadius: "10px" }} />,
  }),
  withScriptjs,
  withGoogleMap
)(({ lat, lng }) => (
  <GoogleMap
    defaultZoom={15}
    defaultCenter={{ lat, lng }}
    options={{
      clickableIcons: false,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: true,
      styles: withThemeMapStyles([
        { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] },
      ]),
    }}
  >
    <Marker
      position={{ lat, lng }}
      icon={{ url: marker, scaledSize: new google.maps.Size(30, 37) }}
    />
  </GoogleMap>
));

export default ScreenMap;
